import { render, staticRenderFns } from "./BaseLogo.vue?vue&type=template&id=380c6dcf&scoped=true&"
import script from "./BaseLogo.vue?vue&type=script&lang=ts&"
export * from "./BaseLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c6dcf",
  null
  
)

export default component.exports